import {
  CREATE_TCA_REQUEST,
  CREATE_TCA_SUCCESS,
  CREATE_TCA_FAILURE,
  CREATE_TCA_RESET,
} from './actionTypes'
import get from 'lodash/get'

import { createTcaForClient } from '../api/mikasa/requests'
import { saveClientAnswer } from './client'
import { CONFIRMED_TCA_REQUEST } from '../constants/client/answers'

import { selectClientId } from '../store/selectors/client'
import { selectHomeUuid } from '../store/selectors/home'
import { getTcaReportKeyFromRefiDetails } from '../store/selectors/tca'

export const createTca = refiData => async (dispatch, getState) => {
  const state = getState()
  const clientId = selectClientId(state)
  const homeId = selectHomeUuid(state)

  dispatch({
    type: CREATE_TCA_REQUEST,
  })

  try {
    const response = await createTcaForClient(homeId, clientId, refiData)

    dispatch({
      type: CREATE_TCA_SUCCESS,
      leadTimeHours: get(response, 'data.data.leadTimeHours', 0),
      tcaUpdated: get(response, 'data.data.tcaUpdated', false),
      reportLink: get(response, 'data.data.reportLink', null),
      reportKey: getTcaReportKeyFromRefiDetails(refiData),
    })
  } catch (error) {
    dispatch({
      type: CREATE_TCA_FAILURE,
      error,
    })
  }
}

export const resetTca = () => async dispatch => {
  dispatch({
    type: CREATE_TCA_RESET,
  })
}

export const clientConfirmTca = () => async dispatch => {
  dispatch(
    saveClientAnswer({
      question: CONFIRMED_TCA_REQUEST,
      response: {
        value: true,
      },
    })
  )
}
